import { TFunction } from "i18next";
import {
  MaterialStockItem,
  PackagingItem,
  ReportItem,
  ReportType,
} from "shared/api";

export const reportTypes: Record<ReportType, string> = {
  [ReportType.MATERIAL_ITEM]: "Material Item",
  [ReportType.REEL_LABEL]: "Reel Label",
  [ReportType.PACKAGING]: "Packaging",
  [ReportType.PALLET_LABEL]: "Pallet Label",
  [ReportType.REEL_LAB_ARCHIVE]: "Reel Lab Archive",
  [ReportType.LAB_REEL_ARCHIVE]: "Reel Lab Archive",
  [ReportType.ORDER]: "Order",
  [ReportType.MULTIPLE_ORDER]: "Multiple Order",
  [ReportType.MULTIPLE_PACKAGING]: "Multiple Packaging",
  [ReportType.LOADING_LIST]: "Loading List",
  [ReportType.MULTIPLE_ORDER_PACKAGING]: "Multiple Order Packaging",
  [ReportType.LOADING_LIST_MULTIPLE]: "Loading List Multiple",
  [ReportType.MULTIPLE_MATERIAL]: "Multiple Material",
  [ReportType.MULTIPLE_QUALITY]: "Multiple Quality",
  [ReportType.LAB_VIEW_FULL_ORDER]: "Lab View Full Order",
  [ReportType.MULTIPLE_MATERIAL_ITEM]: "Multiple Material Item",
  [ReportType.MANAGEMENT]: "Managment",
  [ReportType.MANAGEMENT_DAILY]: "Management Daily",
  [ReportType.MANAGEMENT_WEEKLY]: "Management Weekly",
  [ReportType.DRIGGING_RIGG]: "Drigging Rigg",
  [ReportType.STOCK]: "Stock",
  [ReportType.MULTIPLE_COMPANY_PACKAGING]: "Company Loading List - Multiple",
  [ReportType.QUALITY_ADHESION]: "Quality - Adhesion",
  [ReportType.LOCAL]: "Local",
  [ReportType.REEL_LAB_RESULT_MULTIPLE]: "Reel Lab Result Multiple",
};

export const renderReportType = (report: ReportItem) => {
  const status = reportTypes[report?.report_type as ReportType];
  return status || "Unknown Type";
};

export const renderIsDefaultString = (report: ReportItem) => {
  return report?.is_default ? "Default" : "Not Default";
};

// const normalizeNameToCode = (name: string) =>
//   name
//     .toUpperCase()
//     .replace(/\s*-\s*/g, "_")
//     .replace(/\s+/g, "_");

export const renderReportTypeTitle = (reportType: string, t: TFunction) =>
  t(`reportTypes.${reportType}`, {
    defaultValue: reportType
      .replaceAll("_", " ")
      .toLowerCase()
      .replace(/^\w/, (c) => c.toUpperCase()),
  });

export const renderReportTitle = (report: ReportItem) => {
  return report.name;
};

export const getPackagingDataFromMateriaStockItem = (
  materialStockItem: MaterialStockItem
) => {
  const materialPackagingData = materialStockItem?.packaging as PackagingItem;
  const packagingMaterialId =
    materialPackagingData?.material as unknown as number;

  return {
    id: materialPackagingData?.id,
    name: materialPackagingData?.name,
    material: packagingMaterialId,
    order: materialPackagingData?.order,
  };
};
